<script setup lang="ts">
import { UsaState } from '@/types/Address';

defineProps<{
    modelValue: string|number,
}>();

const emit = defineEmits(['update:model-value']);
const stateOptions = Object.values(UsaState);

</script>
<template>
    <q-select
        v-model="$props.modelValue"
        outlined
        :options="stateOptions"
        label="State"
        class="state"
        lazy-rules
        dense
        :rules="[ val => !!val || 'This field is required']"
        @update:model-value="emit('update:model-value', $event)"
    />
</template>
<style scoped>
</style>
